export default "__VITE_ASSET__DW35EKwV__"